import React from 'react'
import { Switch, Route, Link, useLocation } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import MyRolesIndex from '@/pages/MyRoles/MyRolesIndex'

function breadCrumbs() {
   const location = useLocation()
   const activePath = location.pathname
  const crumbs = [
    { to: '/myroles', name: 'My Roles' }
  ]
  return crumbs
}

function pageTitle() {
  //const location = useLocation()
  //const activePath = location.pathname

  const titleInfo = {
    title: 'My Roles',
    buttons: []
  }

  return titleInfo
}

export default function MyRolesContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/myroles']}>
        <MyRolesIndex />
      </Route>
    </Switch>
  </>
}
